var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F5F7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590_23309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 15.3125V10H13.4375C12.918 10 12.5 10.418 12.5 10.9375V29.0625C12.5 29.582 12.918 30 13.4375 30H26.5625C27.082 30 27.5 29.582 27.5 29.0625V16.25H22.1875C21.6719 16.25 21.25 15.8281 21.25 15.3125ZM23.75 24.5312C23.75 24.7891 23.5391 25 23.2812 25H16.7188C16.4609 25 16.25 24.7891 16.25 24.5312V24.2188C16.25 23.9609 16.4609 23.75 16.7188 23.75H23.2812C23.5391 23.75 23.75 23.9609 23.75 24.2188V24.5312ZM23.75 22.0312C23.75 22.2891 23.5391 22.5 23.2812 22.5H16.7188C16.4609 22.5 16.25 22.2891 16.25 22.0312V21.7188C16.25 21.4609 16.4609 21.25 16.7188 21.25H23.2812C23.5391 21.25 23.75 21.4609 23.75 21.7188V22.0312ZM23.75 19.2188V19.5312C23.75 19.7891 23.5391 20 23.2812 20H16.7188C16.4609 20 16.25 19.7891 16.25 19.5312V19.2188C16.25 18.9609 16.4609 18.75 16.7188 18.75H23.2812C23.5391 18.75 23.75 18.9609 23.75 19.2188Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15V14.7617C27.5 14.5156 27.4023 14.2773 27.2266 14.1016L23.4023 10.2734C23.2266 10.0977 22.9883 10 22.7383 10H22.5V15H27.5Z",
    fill: "#335C75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590_23309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(12.5 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAttachment);
export default __webpack_public_path__ + "static/media/MobileAttachment.78408ae51a6aa0e41e3bf739b2fcb66c.svg";
export { ForwardRef as ReactComponent };